module.exports = __webpack_public_path__ + "static/media/visione-laterale-struttura-completa-canestro-noleggiocampi.98912640.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/basket/slider3/visione-laterale-struttura-completa-canestro-noleggiocampi.jpg
// module id = 635
// module chunks = 0